<template>
  <div>
    <div class="row" v-if="progress && progress.TotalRows">
      <div class="col-2">
        {{ $t('importtask.records') }}
      </div>
      <div class="col">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            :style="`width: ${rowProgress}%;`"
            :aria-valuenow="progress.CurrentRow"
            aria-valuemin="0"
            :aria-valuemax="progress.TotalRows"
          >
            {{ progress.CurrentRow }}/{{ progress.TotalRows }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'import-progress',
  props: {
    progress: {
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    rowProgress() {
      if (this.progress && this.progress.TotalRows > 0) {
        let current = this.progress.CurrentRow;

        if (current === 0) {
          return 0;
        }
        let percentage = (current / this.progress.TotalRows) * 100;
        return Math.round(percentage * 100) / 100;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.progress,
.progress-bar {
  height: 100%;
}
</style>
